export class CreateLeadResponse {

    private _name: string = null;
    private _surname: string = null;
    private _idNumber: string = null;
    private _cellPhone: string = null;
    private _email: string = null;
    private _leadReferenceNumber: Number = null;

    constructor() {
    }

    get name(): string {
      return this._name;
    }

    set name(value: string) {
      this._name = value;
    }

    get surname(): string {
      return this._surname;
    }

    set surname(value: string) {
      this._surname = value;
    }

    get idNumber(): string {
      return this._idNumber;
    }

    set idNumber(value: string) {
      this._idNumber = value;
    }

    get cellPhone(): string {
      return this._cellPhone;
    }

    set cellPhone(value: string) {
      this._cellPhone = value;
    }

    get email(): string {
      return this._email;
    }

    set email(value: string) {
      this._email = value;
    }

    get leadReferenceNumber(): Number {
        return this._leadReferenceNumber;
    }

    set leadReferenceNumber(value: Number) {
        this._leadReferenceNumber = value;
    }
  }
